<script setup lang="ts">
import { toRefs } from 'vue';
import { OverageListInterface } from '@/types';
import SeatsPerDisciplineHeader from './SeatsPerDisciplineHeader.vue';
import StudentInSeat from './StudentInSeat.vue';

interface Props {
  overage: OverageListInterface;
}

const props = defineProps<Props>();

const { overage } = toRefs(props);
</script>

<template>
  <div class="flex w-full flex-column px-3 py-1 mt-3 mb-4">
    <SeatsPerDisciplineHeader :overage="overage" />
    <table class="w-full mt-2">
      <thead>
        <tr>
          <th>Completed Students</th>
          <th>Scheduled Students</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="w-6 p-0">
            <StudentInSeat v-if="overage.completed_students.length" :students="overage.completed_students" />
            <div v-else class="student p-3 justify-content-center text-center">
              No completed students for this discipline
            </div>
          </td>
          <td class="w-6 p-0">
            <StudentInSeat v-if="overage.scheduled_students.length" :students="overage.scheduled_students" />
            <div v-else class="student p-3 justify-content-center text-center">
              No scheduled students for this discipline
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped lang="scss">
table {
  thead {
    th {
      text-align: left;
      padding: 1rem;
      font-weight: 600;
      color: #495057;
      background: #f8f9fa;
      transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
      background: var(--surface-50);
      border: 1px solid var(--surface-50);
    }
  }

  tr {
    td {
      text-align: left;
      padding: 1rem 1rem;
      background: white;
      vertical-align: top;
    }
  }
}
</style>
